export function loadGAPI () {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script')
    script.src = 'https://apis.google.com/js/api.js'
    script.onreadystatechange = script.onload = function () {
      var interval = setInterval(function () {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          clearInterval(interval)

          window.gapi.load('client:auth2', () => {
            resolve(window.gapi)
          })
        }
      }, 100)
    }
    document.getElementsByTagName('head')[0].appendChild(script)
  })
}

// function gapiAuth () {
//   var tokenObject = {
//     access_token: authData.google.accessToken
//   };
//   // set the authentication token
//   gapi.auth.setToken(tokenObject);
// }
